import { IBaseConfiguration } from './config.types';

export const DevOptions: IBaseConfiguration = {
  baseUrl: 'http://localhost:5000/api',
  hubUrl: 'http://localhost:5000/notificationHub',
  projectHubUrl: 'http://localhost:5000/projectHub',
  uploadsHubUrl: 'http://localhost:5000/uploadsHub',
  version: '1.0.0',
};
